import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Slider from 'react-slick';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import PaginationButton from '@cotyorg/ccx-organism-carousel/components/PaginationButton';

const generatePaginationClassNames = ({
  positionX,
  positionY,
  isOverlayed,
  type,
}) =>
  classNames(
    'carousel__pagination',
    'align-center',
    `carousel__pagination--${positionX}`,
    `carousel__pagination--${positionY}`,
    {
      'flex-container': positionX === 'centre',
      'carousel__pagination--overlayed': isOverlayed,
      'carousel__pagination--thumbnail': type === 'thumbnails',
    }
  );

const generatePaginationInnerClassNames = ({ hasBackground }) =>
  classNames('carousel__pagination-inner', {
    'carousel__pagination-inner--has-background': hasBackground,
  });

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 10000,
      settings: 'unslick',
    },
  ],
};

const Pagination = ({
  carouselsStoreDataKey,
  positionX,
  positionY,
  type,
  buttons,
  hasBackground,
  currentIndex,
  setIndex,
  noOfPages,
  isOverlayed,
  onIndexChange,
  galleryData,
  sliderRef,
}) => (
  <div
    className={generatePaginationClassNames({
      positionX,
      positionY,
      isOverlayed,
      type,
    })}
  >
    <Slider
      className={generatePaginationInnerClassNames({ hasBackground })}
      {...sliderSettings}
      ref={sliderRef}
    >
      {[...Array(noOfPages)].map((item, index) => (
        <PaginationButton
          key={uuid()}
          buttonIndex={index}
          carouselsStoreDataKey={carouselsStoreDataKey}
          type={type}
          currentIndex={currentIndex}
          setIndex={setIndex}
          onIndexChange={onIndexChange}
          {...buttons}
          picture={R.propOr({}, 'images', galleryData)[index]}
        />
      ))}
    </Slider>
  </div>
);

Pagination.defaultProps = {
  positionX: 'centre',
  positionY: 'bottom',
  type: 'lines',
  hasBackground: false,
  isOverlayed: true,
};

Pagination.propTypes = {
  positionX: PropTypes.oneOf(['left', 'centre', 'right']),
  positionY: PropTypes.oneOf(['top', 'middle', 'bottom']),
  carouselsStoreDataKey: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['lines', 'numbers', 'thumbnails']),
  buttons: PropTypes.objectOf(PropTypes.any),
  hasBackground: PropTypes.bool,
  noOfPages: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  setIndex: PropTypes.func.isRequired,
  isOverlayed: PropTypes.bool,
  onIndexChange: PropTypes.func,
  galleryData: PropTypes.objectOf(PropTypes.any),
  sliderRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

export default Pagination;
